let productSlider = null;
let quickShopSlider = null;

/**
  * Open Modal javascript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
  * prevent body Touch event in Touch devices when Overlay is visible
  *
  * @param {event} event - event instance
*/
function bodyTouchMove(event){
  let currentTarget = event.target;
  if (!currentTarget.closest('[data-touch-moveable]')) {
    event.preventDefault();
    return false;
  }
}

/**
  * Limit the number of times a function is called within defined timeout
  *
  * @param {form} form - Form to serialize
*/
const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/**
  * Fetch call config
  *
  * @param {string} type - request Accept type
*/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 function dropDownInit(element){
 
  const dropdownParent = element.parentElement;
  const dropdownEle = element;
 
  ["mouseover", "focusin",  "click", "mouseout"].forEach(function(type){
    if(type == 'click'){
      dropdownEle.addEventListener(type, (evt) => {
        evt.stopPropagation();
        let currentTarget = evt.currentTarget;
        let liveTarget = evt.target;
        dropdownToggle(dropdownParent);
        /*
        if(liveTarget.classList.contains('nav-link-title')){
          let linkHref = currentTarget.getAttribute('data-href');
          if(linkHref) window.location.href = linkHref;
        }else {
          dropdownToggle(dropdownParent);
        }
        */
      });
    }else if(type == 'mouseout'){
      dropdownParent.addEventListener(type, (event) => {
        let mobileContainer = event.currentTarget.closest('[data-touch-moveable]');
        if(!mobileContainer){
          dropdownHide(dropdownParent);
        }
      }, true);
    } else if(type == 'mouseover' || type == 'focusin'){
      dropdownParent.addEventListener(type, (event) => {
        let mobileContainer = event.currentTarget.closest('[data-touch-moveable]');
        if(!mobileContainer){
          dropdownShow(dropdownParent); 
        }
      });
      dropdownEle.addEventListener(type, (e) => { ChildonFocusChange(dropdownParent); });
    }
  });

  dropdownParent.addEventListener('keyup', (event) => {
    if (event.code.toUpperCase() === 'ESCAPE'){ dropdownHide(event.currentTarget, event.type); }
    if (event.code.toUpperCase() === 'ENTER'){ dropdownShow(event.currentTarget); }
  });

  function dropdownToggle(dropdownParent) {
    setTimeout(function(){
      dropdownParent.classList.contains('open')
        ? dropdownHide(dropdownParent)
        : dropdownShow(dropdownParent);
    }, 50);
  }

  function dropdownShow(dropdownParent){
    if(!dropdownParent){
      return;
    }

    dropdownEle.setAttribute('aria-expanded', true);
    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.add('open');
    }else{
      Utility.toggleElement(dropdownParent, 'open');
    }
  }

  function dropdownHide(dropdownParent, eventType){
    if(!dropdownParent){
      return;
    }

    dropdownEle.setAttribute('aria-expanded', false);
    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.remove('open');
    }else{
      Utility.toggleElement(dropdownParent, 'close');
    }

    if(eventType == 'mouseout' && dropdownParent.parentElement.closest('.dropdown')){
      dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
    }

    let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if(childDropdowns.length > 0){
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        if(child.querySelector('a[data-toggle="open"]'))
          child.querySelector('a[data-toggle="open"]').setAttribute('aria-expanded', false);
      });
    }
  }

  function ChildonFocusChange(dropdownParent){
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if(eleIndex != currentIndex){ dropdownHide(ele); }
    });
  }

  let closeBtn = dropdownParent.querySelector('.close-submenu');
  if(closeBtn){
    closeBtn.addEventListener('click', (event)=>{
      event.preventDefault();
      let parentElement = event.currentTarget.closest('.dropdown');
      dropdownToggle(parentElement);
    });
  };
}

const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach(function(ele) {
  dropDownInit(ele)
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
function defaultNavItem(element){
  let _this = element;
  ["focusin", "click", "mouseover", "mouseout"].forEach(function(type){
    _this.addEventListener(type, (e) => {
      e.stopPropagation();
      let currentTarget = e.currentTarget;
      if(!currentTarget.closest('[data-touch-moveable]')){
        hideDropdown(_this.parentElement);
      }
    });
  });

  _this.addEventListener('touchend', (e) => {
    e.stopPropagation();
  });
  
  function hideDropdown(dropdownParent){
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
      ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
    });
  }
}

const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach(function(ele) {
  defaultNavItem(ele);
});

/**
* Website Overlay for Mobile Menu and Cart Drawer
*/
class siteOverlay extends HTMLElement{
  constructor() {
    super();

    this.menuDrawer = document.querySelector('#mobile-menu-drawer');
    this.cartDrawer = document.querySelector('#ajax-cart');
    this.searchDrawer = document.querySelector('search-modal');
  }

  connectedCallback() {
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event){
  
    if(this.cartDrawer && this.cartDrawer.classList.contains('opened-drawer')){
      document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
    if(this.menuDrawer && this.menuDrawer.classList.contains('opened-drawer')){
      //document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
      document.querySelector('#mobile-menu.openmenulink').dispatchEvent(new Event('click'));
    }
    if(this.searchDrawer && this.searchDrawer.classList.contains('open__modal')){
      document.querySelector('.search-modal__close-button').dispatchEvent(new Event('click'));
    }
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    if (document.querySelector('#PopupModal-video .modal.open')) {
      document.querySelector('html').style.overflow = "hidden";
      document.querySelector('body').style.position = "static";
    }
    document.getElementById('site-overlay').classList.add('overlay--body');
    document.querySelector('body').classList.add('scroll-fixed');
    document.body.style.overflowY = "hidden";
  }

  /**
   * Hide overlay 
   */
  hideOverlay(){
    document.getElementById('site-overlay').classList.remove('overlay--body');
    document.querySelector('body').classList.remove('scroll-fixed');
    document.querySelector('html').style.overflow = "";
    document.querySelector('body').style.position = "";
    document.body.style.overflowY = "";
  }
}
customElements.define("site-overlay", siteOverlay);

/**
 * Slider Component
 *
 */
 class sliderElement extends HTMLElement{
  constructor() {
    super();
    this.sliderEle = this.querySelector('.swiper-slider');
    
    if(window.globalVariables.template == 'product' && this.classList.contains('product-main-slider')){
      if(document.querySelector('#proImgSwitch')){
        document.querySelector('#proImgSwitch').addEventListener('click', (event) => {
          this.connectedCallback();
        }); 
      }
    }
  }

  connectedCallback() {
    if(!this.sliderEle) return;
    
    let thumbSlider = null;
    let sliderOptions = this.sliderEle.getAttribute('data-slider');
    sliderOptions = JSON.parse(sliderOptions);
    let _this = this;

    if(this.sliderEle.querySelectorAll('[data-hover-video-play]').length){
      let sliderImages = this.sliderEle.querySelectorAll('[data-hover-video-play]');
      sliderImages.forEach(slideEle => {
        slideEle.addEventListener('mouseover',e => {
          if(slideEle.querySelector('[data-hover-video]')?.getAttribute('data-hover-video') != ''){
            let video = _this.querySelector('video');
            video.play();
          }
        })
        slideEle.addEventListener('mouseleave',e => {
          if(slideEle.querySelector('[data-hover-video]')?.getAttribute('data-hover-video') != ''){
            let video = _this.querySelector('video');
            video.pause();
          }
        })
      })
    }

    // Set up nav slider 
    if(this.sliderEle.hasAttribute('data-nav')){
      thumbSlider = document.querySelector('.' + this.sliderEle.getAttribute('data-nav'));
      if(thumbSlider == null){
        return;
      }

      let thumbSliderOptions = thumbSlider.getAttribute('data-slider');
      thumbSliderOptions = JSON.parse(thumbSliderOptions);
      thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);

      sliderOptions.thumbs = {
        swiper: thumbSlider
      }
    }

    let sliderInstance = new Swiper(this.sliderEle, sliderOptions);
    if(this.sliderEle.classList.contains('product-carousel')){
      productSlider = sliderInstance;
    }else if(this.sliderEle.classList.contains('quickshop-slider')){
      quickShopSlider = sliderInstance;
    }

    this.slideChangeEvt(sliderInstance, thumbSlider);
  }

  slideChangeEvt(slider, thumbSlider){   
    slider.on('slideChangeTransitionEnd', (event) => {
      const currentTarget = event.el;
      let activeVideos = currentTarget.querySelectorAll('.custom-video-container.playing--video');
      if(activeVideos.length > 0){        
        activeVideos.forEach((container)=>{
          let video = container.querySelector('custom-video');
          let videoType = video.getAttribute('data-video-type');
          let videoEle = video.querySelector('video') || video.querySelector('iframe');
          if(videoType == 'local'){
            videoEle.pause();
            container.classList.remove('playing--video')
          }else if(videoType == 'youtube'){
            container.classList.remove('playing--video')
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
      }
    });
  }
 }
 let lookForSwiper = setInterval(() => {
  if(typeof Swiper == 'function'){
    customElements.define('slider-element', sliderElement);
    clearInterval(lookForSwiper);
  } 
}, 100);

/**
* Custom Video
*/
class customVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoTopText = this.getAttribute('data-video-top-heading') ?? null;
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    if(this.container){
      this.triggerVideo = this.container.querySelector('[data-trigger-video]');
      this.customControls = this.container.querySelector('[data-custom-controls]') ?? null;
      this.posterVideo = this.querySelector('[data-postervideo]') ?? null;
      if (this.customControls && this.posterVideo) {
        this.controlReplay = this.customControls.querySelector('.video-banner-custom-video-controls-replay svg') ?? null;
        this.controlPause = this.customControls.querySelector('.video-banner-custom-video-controls-pause svg') ?? null;
        this.controlVolume = this.customControls.querySelector('.video-banner-custom-video-controls-volume svg') ?? null;
      }
    }


    this.bindEvents();
  }

  connectedCallback() {
    // Connected callback
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
    if(this.controlReplay) {
      this.controlReplay.addEventListener('click', this.CustomControlReplay.bind(this));
      this.controlReplay.addEventListener('keyup', (event) => {
        if (event.key === 'Enter') this.CustomControlReplay(event);
      });
    }
    if(this.controlPause) {
      this.controlPause.addEventListener('click', this.CustomControlPause.bind(this));
      this.controlPause.addEventListener('keyup', (event) => {
        if (event.key === 'Enter') this.CustomControlPause(event);
      });
    }
    if(this.controlVolume) {
      this.controlVolume.addEventListener('click', this.CustomControlVolume.bind(this));
      this.controlVolume.addEventListener('keyup', (event) => {
        if (event.key === 'Enter') this.CustomControlVolume(event);
      });    
    }
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(_event){
    let isOpen = this.container.classList.contains('playing--video');
    if(isOpen){
      this.container.classList.remove('playing--video');
      if(window.globalVariables.template == 'product'){
        this.videoSection.classList.remove('d-block');
      }
    }else{
      if(this.videoStatus == 'empty' || this.placementType == 'popup'){
        const videoElement = this._buildVideo();
        videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
        this.videoSection.appendChild(videoElement);
        this.videoStatus = 'loaded';
        if(document.querySelector('body').getAttribute('data-suffix') != 'dmb-pro'){
          if(this.placementType == 'grid') this.contentSection.classList.add('d-none');
          this._playVideo(videoElement);
        }
        setTimeout(() => {
          if (this.placementType == 'popup') {
            if (this.videoModal.querySelector('[data-video-top-heading]') && this.videoTopText) {
              this.videoModal.querySelector('[data-video-top-heading]').innerHTML = this.videoTopText;
            }
            openModal(this.videoModal, this.triggerVideo);
          } else {
            this.container.classList.add('playing--video');
          }
          if(document.querySelector('body').getAttribute('data-suffix') != 'dmb-pro'){
            this.pauseOnVisibilityChange(videoElement);
            this._playVideo(videoElement);
          }
        }, 700);     
        this.querySelector('.cta-btn')?.classList.add('d-none');
      }else{
        const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
        this.container.classList.add('playing--video');
        this._playVideo(videoElement);
      }
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      let videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "src", "https://www.youtube.com/embed/"+ videoID +`?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}` );
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    let scrollObserver = new IntersectionObserver((entries) => { 
      if((this.type == 'local' && videoEle == undefined) || (this.type == 'youtube' && videoEle.contentWindow == null)){
        scrollObserver.disconnect();
        return;
      }

      entries.forEach(entry => {
        if(entry.intersectionRatio == 0){
          if(this.type == 'local'){
            videoEle.pause();
            if(window.globalVariables.template == 'product'){
              this.container.classList.remove('playing--video');
              this.videoSection.classList.add('d-block');
            }
          }else if(this.type == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      });
    });
    scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    let posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo || posterVideo == undefined) return;

    // Function to check if captions are active and showing
    const checkCaptionsActive = () => {
      const textTracks = posterVideo.textTracks;
      for (let i = 0; i < textTracks.length; i++) {
        const track = textTracks[i];
        if (track.kind === 'captions' && track.mode === 'showing' && track.activeCues && track.activeCues.length > 0) {
          return true;
        }
      }
      return false;
    };

    // Function to toggle heading visibility based on caption state
    const toggleHeadingVisibility = (show) => {
      const headings = document.querySelectorAll('[data-hide-on-play]');
      const captionsActive = checkCaptionsActive();

      headings.forEach(heading => {
        if (captionsActive === true)
          heading.style.display = show === true ? '' : 'none';
        else
          heading.style.display = '';
      });
    };

    posterVideo.addEventListener("playing", (event) => {
      toggleHeadingVisibility(false);
    });
    posterVideo.addEventListener("play", (event) => {
      toggleHeadingVisibility(false);
    });
    posterVideo.addEventListener("pause", (event) => {
      toggleHeadingVisibility(true);
    });
    posterVideo.addEventListener("ended", (event) => {
      toggleHeadingVisibility(true);
    })

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          let sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  /**
   * Replay video
   *
  */
  CustomControlReplay() {
    this.posterVideo.currentTime = 0;
    this.posterVideo.play();
    this.controlPause.classList.remove("active");
    this.controlPause.querySelector('use').setAttribute('href', '#icon-pause');
  }
  /**
   * Pause video
   *
  */
  CustomControlPause() {
    if (this.posterVideo.paused || this.posterVideo.ended) {
      this.posterVideo.play();
      this.controlPause.classList.remove("active");
      this.controlPause.querySelector('use').setAttribute('href', '#icon-pause');
    } else {
      this.posterVideo.pause();
      this.controlPause.classList.add("active");
      this.controlPause.querySelector('use').setAttribute('href', '#icon-video-play');
    }
  }
  /** 
   * Mute/Unmute video
   * 
  */
  CustomControlVolume() {
    if (this.posterVideo.muted) {
      this.posterVideo.muted = false;
      this.controlVolume.classList.add("active");
      this.controlVolume.querySelector('use').setAttribute('href', '#icon-volume');
    } else {
      this.posterVideo.muted = true;
      this.controlVolume.classList.remove("active");
      this.controlVolume.querySelector('use').setAttribute('href', '#icon-mute');
    }
  }
}
customElements.define("custom-video", customVideo);

/**
  * Open Modal javascript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = document.querySelectorAll('[data-modal-opener="'+this.id+'"]');
  }

  connectedCallback() {
    if(this.modalOpeners.length > 0) {
      this.modalOpeners.forEach((opener)=>{
        opener.addEventListener('click', ()=>{
          this.show(opener);
        });
      });
    }

    if(this.querySelector('[id^="ModalClose-"]')){
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
    }

    this.addEventListener('click', (evt) => {
      if (evt.target.nodeName === 'MODAL-DIALOG') this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    siteOverlay.prototype.hideOverlay();
    //Utility.removeTrapFocus(this.openedBy);

    if(this.id == 'PopupModal-video'){
      this.querySelector('.video-container').innerHTML = '';
      if (this.querySelector('[data-video-top-heading]')) {
        this.querySelector('[data-video-top-heading]').innerHTML = '';
      }
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class Notification extends HTMLElement {
  constructor() {
    super();

    this.paused = false;
    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
  }

  connectedCallback() {
    this.container.addEventListener('mouseover', (event) =>{
      this.paused = true;
    });
    this.container.addEventListener('mouseout', (event) =>{
      this.paused = false;
    });

    if(this.closeBtn){
      this.closeBtn.addEventListener('click', (e)=> {
        e.preventDefault();
        this.container.classList.remove('open');
        this.querySelector('.snotifyToast__title').innerHTML = '';
        this.querySelector('.snotifyToast__body').innerHTML = '';
        this.container.classList.remove("snotify-warning","snotify-info","snotify-error","snotify-success");
        this.querySelector("[data-toast-pr]").removeAttribute("style");
      });
    }
  }

  /**
   * Notification Type
   * @param title 
   * @param body 
   * @param options 
   */
  updateNotification(title, body, options){
    this.container.className = '';
    this.querySelector('.snotifyToast__title').innerHTML = title;
    this.querySelector('.snotifyToast__body').innerHTML = body;

    this.container.classList.add('snotifyToast');
    if(options.type == 'error'){
      this.container.classList.add('snotify-error');
    }else if(options.type == 'warning'){
      this.container.classList.add('snotify-warning');
    }else if(options.type == 'info'){
      this.container.classList.add('snotify-info');
    }else if(options.type == 'success'){
      this.container.classList.add('snotify-success');
    }

    this.container.classList.add('open');
    this.manageToggle(options.timeout)
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  manageToggle(timeout){
    this.progressBar = this.querySelector('[data-toast-pr]');
    let unit = parseInt(timeout) / 1000;
    unit = 100 / unit;
    let width = 0;

    let interval = setInterval(() => {
      if(this.paused == false){
        width += unit;
        this.progressBar.setAttribute('style', `width: ${width}%`);
        if (width > 100) {
          this.closeBtn.dispatchEvent(new Event('click'));
          clearInterval(interval);
        }
      }
    }, 1000)
  }
}
customElements.define("custom-notification", Notification);
window.notificationEle = document.querySelector('custom-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 10000
// });

setInterval(function(){
  let timeStampVideos = document.querySelectorAll('video[data-timestampvideo]');
  timeStampVideos.forEach(video => {
    if(video.paused){
      if(video.currentTime == parseInt(video.getAttribute('data-timestampvideo'))){
        video.pause();
      }else{
        video.load();
      }
    }
  })
},500)
const onDocumentReadyAndWindowResize = () => {
  const siteHeader = document.querySelector('.shopify-section-group-header-group.section-header') ?? null;
  const siteHeaderHeight = siteHeader?.offsetHeight ?? 0;
  const stickyTopWrapper = document.querySelector('.sticky-top__wrapper') ?? null;
  const sortbyWrapper = document.querySelectorAll('.collection-filter-sorting__wrapper .custom-dropdown .toggle-content') ?? null;
  let windowScrollTop;
  if(siteHeader && stickyTopWrapper) {
    siteHeader.classList.remove("header-sticky");

    function setstickyTopWrapperHeight (topspacing, windowscrolltop) {
        if (windowscrolltop) {
            siteHeader.classList.add("header-sticky");
            stickyTopWrapper.style.top = topspacing + "px";
        } else {
            siteHeader.classList.remove("header-sticky");
            stickyTopWrapper.style.top = 0;
        }
        if (window.scrollY > topspacing) {
          stickyTopWrapper.classList.add("sticky-border-bottom");
          if (sortbyWrapper.length > 0) {
            sortbyWrapper.forEach(element => {
              element.style.borderTop = "0";
            });
          }
        } else {
          stickyTopWrapper.classList.remove("sticky-border-bottom");
          if (sortbyWrapper.length > 0) {
            sortbyWrapper.forEach(element => {
              element.style.borderTop = "";
            })
          }
        }
    }
    window.onscroll = function(e) {
        // "false" if direction is down and "true" if up
        windowScrollTop = this.oldScroll > this.scrollY;
        setstickyTopWrapperHeight(siteHeaderHeight, windowScrollTop);
        this.oldScroll = this.scrollY;
    }
    setstickyTopWrapperHeight(siteHeaderHeight, 0);
  }
};
// Execute the function when the document is fully loaded
document.addEventListener('DOMContentLoaded', onDocumentReadyAndWindowResize);

// Execute the function when the window is resized
window.addEventListener('resize', onDocumentReadyAndWindowResize);

// Open external url in new tab

window.addEventListener("DOMContentLoaded", e =>
{
  document.querySelectorAll('a[href]').forEach(a =>
  {
    if (location.hostname == new URL(a.href).hostname || a.href == "javascript:void(0);" || a.href == "#")
      return;

    a.target = "_blank";
    a.rel = "noreferrer nofollow noopener";
  });
});

/********************
 *** Header slider video slide js
*********************/

let fullImageSlideVideo = document.querySelectorAll("[data-fullImageSlideVideo]");

if (fullImageSlideVideo.length > 0) {
  fullImageSlideVideo.forEach((videoSlide) => {
    let videoSlideUrl = videoSlide.dataset.src;
    if(window.screen.width <= 767 && videoSlide.dataset.mobileSrc){
      videoSlideUrl = videoSlide.dataset.mobileSrc;
      if(videoSlide.dataset.mobilePoster){
        videoSlide.poster = videoSlide.dataset.mobilePoster;
      }
    }
    videoSlide.src = videoSlideUrl;
    videoSlide.play();
  })
}

/********************
 *** Header slider video slide js END
*********************/